import { KnmDataViolationPathsTemplateEnum } from 'APIPackage/KnmModule/enums/KnmDataViolationPathsTemplateEnum';

import { MenuItemsIdsEnum } from '../enums/MenuItemsIdsEnum';

type IKnmSectionsViolationsPathsTemplateMap = {
  [key in keyof typeof MenuItemsIdsEnum]: Array<KnmDataViolationPathsTemplateEnum[number]>;
};

export const knmSectionsViolationsPathsTemplatesMap: IKnmSectionsViolationsPathsTemplateMap = {
  [MenuItemsIdsEnum.KNM_INFO]: [
    KnmDataViolationPathsTemplateEnum.TYPE,
    KnmDataViolationPathsTemplateEnum.KIND,
    KnmDataViolationPathsTemplateEnum.ATR,
    KnmDataViolationPathsTemplateEnum.DATE,
    KnmDataViolationPathsTemplateEnum.START_DATE,
    KnmDataViolationPathsTemplateEnum.STOP_DATE,
    KnmDataViolationPathsTemplateEnum.LEGAL_BASES,
    KnmDataViolationPathsTemplateEnum.LEGAL_BASES_ITEM,
    KnmDataViolationPathsTemplateEnum.INSPECTION_TARGET,
    KnmDataViolationPathsTemplateEnum.DURATION_DAYS,
    KnmDataViolationPathsTemplateEnum.DURATION_HOURS,
    KnmDataViolationPathsTemplateEnum.EVENTS,
    KnmDataViolationPathsTemplateEnum.EVENTS_ITEM,
  ],
  [MenuItemsIdsEnum.KNM_REQUIREMENTS]: [
    KnmDataViolationPathsTemplateEnum.REQUIREMENTS,
    KnmDataViolationPathsTemplateEnum.REQUIREMENTS_ITEM,
  ],
  [MenuItemsIdsEnum.KNM_CHECK_SHEETS]: [KnmDataViolationPathsTemplateEnum.CHECKLISTS],
  [MenuItemsIdsEnum.KNM_APPROVE_INFO]: [],
  [MenuItemsIdsEnum.KNM_CONTROL_AGENCY]: [
    KnmDataViolationPathsTemplateEnum.KNO_ORGANIZATION,
    KnmDataViolationPathsTemplateEnum.FUNCTIONS,
    KnmDataViolationPathsTemplateEnum.FUNCTIONS_ITEM,
    KnmDataViolationPathsTemplateEnum.INSPECTORS,
    KnmDataViolationPathsTemplateEnum.INSPECTORS_ITEM,
    KnmDataViolationPathsTemplateEnum.SUPERVISION_TYPE,
  ],
  [MenuItemsIdsEnum.KNM_VERIFIED_PERSON]: [
    KnmDataViolationPathsTemplateEnum.INN,
    KnmDataViolationPathsTemplateEnum.OGRN,
    KnmDataViolationPathsTemplateEnum.NAME,
    KnmDataViolationPathsTemplateEnum.OBJECTS,
    KnmDataViolationPathsTemplateEnum.OBJECTS_ITEM,
    KnmDataViolationPathsTemplateEnum.SUPERVISIONS,
    KnmDataViolationPathsTemplateEnum.IMPOSSIBLE_CONDUCTION_REASON,
  ],
  [MenuItemsIdsEnum.KNM_NOTICE_INFO]: [
    KnmDataViolationPathsTemplateEnum.NOTICE_METHOD,
    KnmDataViolationPathsTemplateEnum.NOTICE_DATE,
  ],
  [MenuItemsIdsEnum.KNM_RESULTS]: [
    KnmDataViolationPathsTemplateEnum.RESULT,
    KnmDataViolationPathsTemplateEnum.RESULT_ACT_CREATE_DATE,
    KnmDataViolationPathsTemplateEnum.RESULT_START_DATE,
    KnmDataViolationPathsTemplateEnum.RESULT_DURATION_DAYS,
    KnmDataViolationPathsTemplateEnum.RESULT_DURATION_HOURS,
    KnmDataViolationPathsTemplateEnum.RESULT_INSPECTORS,
    KnmDataViolationPathsTemplateEnum.RESULT_INSPECTORS_ITEM,
    KnmDataViolationPathsTemplateEnum.RESULT_DELEGATES,
    KnmDataViolationPathsTemplateEnum.RESULT_DELEGATES_ITEM,
    KnmDataViolationPathsTemplateEnum.RESULT_ADDITIONAL_INFO,
    KnmDataViolationPathsTemplateEnum.RESULT_ADDITIONAL_INFO_ITEM,
  ],
  [MenuItemsIdsEnum.KNM_VIOLATIONS_LIST]: [],
  [MenuItemsIdsEnum.KNM_LAWSUITS]: [KnmDataViolationPathsTemplateEnum.LAWSUITS],
  [MenuItemsIdsEnum.KNM_CANCELLATION_INFO]: [],
  [MenuItemsIdsEnum.KNM_SIGN_INFO]: [],
  [MenuItemsIdsEnum.KNM_DOCUMENTS]: [],
  [MenuItemsIdsEnum.KNM_PREVIOUS]: [],
  [MenuItemsIdsEnum.KNM_LINKS]: [],
  [MenuItemsIdsEnum.KNM_HISTORY]: [],
  [MenuItemsIdsEnum.KNM_EXECUTION_HISTORY]: [],
};
